module.exports = __webpack_public_path__ + "static/media/logo-zoho-crm.534a427f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-zoho-crm.png
// module id = 1313
// module chunks = 17